<div class="podcast-slide isPodcastSlideOpen">
    <div class="top-content">
        <div class="left-box">
            Daily D.O.S.E&trade;
        </div>
        <div class="right-box">
            <mat-icon *ngIf="currentUrl === '/my-dashboard'" (click)="setPIPValue('maximize')" style="transform: rotate(270deg);">open_in_new_down</mat-icon>
            <mat-icon (click)="setPIPValue('close')" style="transform: rotate(0deg);">close</mat-icon>
        </div>
    </div>
    <div class="middle-content">
        <div class="left-box">
            <img [src]="selectedPodcast && selectedPodcast.artwork_url ? selectedPodcast.artwork_url : '../../assets/images/Daily D.O.S.E Podcast TILE_Lemon.png'" alt="podcast image">
        </div>
        <div class="right-box">
            <div class="top-player-box">
                <div class="play-btn">
                    <mat-icon (click)="onPlayPause()">{{isPlaying ? 'pause' : 'play_arrow'}}</mat-icon>
                </div>
                <div class="date-titile" *ngIf="!isLoadingWavesurfer; else loadingWavesurfer">
                    <div class="date" *ngIf="selectedPodcast && selectedPodcast.formattedPublishingDate">{{ selectedPodcast.formattedPublishingDate }}</div>
                    <!-- <div class="podcast-title">{{ selectedPodcast && selectedPodcast.title ? selectedPodcast.title : "" }}</div> -->
                    <marquee class="podcast-title" *ngIf="selectedPodcast && selectedPodcast.title; else noTitle" style="color: white;" behavior="scroll" direction="left" scrollamount="2">{{selectedPodcast.title}}</marquee>
                    <ng-template #noTitle>
                        <marquee class="podcast-title" behavior="scroll" direction="left" scrollamount="2"></marquee>
                    </ng-template>
                </div>

				<ng-template #loadingWavesurfer>
					<p class="podcast-title">
						Loading podcast audio...
					</p>
				</ng-template>
            </div>
            <div class="middle-player-box">
				<div #waveform></div>
			</div>
        </div>
    </div>
    <div class="last-action-box">
        <div class="volume custom-pip-volume">
            <mat-icon (click)="toggleMute()">{{isMuted ? 'volume_off' : 'volume_up'}}</mat-icon>
            <!-- <input type="range" id="volumeRange" min="0" max="100" step="1" value="100" (input)="changeVolume($event.target.value)"> -->
            <mat-slider *ngIf="!isiPhone"
                class="custum-pip-slider"
                [max]="100"
                [min]="0"
                [step]="1"
                [value]="100"
                (input)="changeVolume($event.value)">
            </mat-slider>
        </div>
        <div class="action-btn-box" [ngStyle]="{'gap': isiPhone ? '15px' : ''}">
            <mat-icon (click)="skipBackwardFn()" id="ten">replay_10</mat-icon>
            <mat-icon (click)="skipForwardFn()" id="ten">forward_10</mat-icon>
            <mat-icon (click)="toggleIsLiked()" [ngClass]="{'active': isLiked}">favorite</mat-icon>
        </div>
        <p class="click-drag-text">Click to Drag Me Around!</p>
    </div>
</div>